import { consumerQuoteKey } from '@shared/consumerPlan';
import { PolicyTermsList } from '../components/policy-terms-list';
import { SelectedCoverageSummary } from '../components/selected-coverage-summary';
import { StepFrame } from '../components/step-frame';
import { useConsumerFlow } from '../hooks/use-consumer-flow';
import { useCoverageSelection } from '../hooks/use-coverage-selection';
import type { ConsumerStepProps } from './step-props';

export function PolicyTermsStep({ clientId }: ConsumerStepProps) {
  const { finish } = useConsumerFlow(clientId);
  const { selectedQuote, projections, scenario } = useCoverageSelection(clientId);
  if (!selectedQuote || !scenario) return null;

  return (
    <StepFrame
      step="policy-terms"
      title="What does this policy allow?"
      onBack={() => finish('coverage')}
      help={
        <>
          <p>Reimbursement is limited by covered expenses. Cash benefits follow eligibility and contract limits.</p>
          <p>*An ongoing premium total assumes today’s premium until care starts; increases can change it.</p>
        </>
      }
      primary={{ label: 'Got it', onClick: () => finish('coverage') }}
    >
      <SelectedCoverageSummary quote={selectedQuote} />
      <PolicyTermsList
        quote={selectedQuote}
        projection={projections.get(consumerQuoteKey(selectedQuote))}
        careStartAge={scenario.careStartAge}
        yearsUntilCare={scenario.yearsUntilCare}
      />
    </StepFrame>
  );
}
